import React from 'react';
import { PadlessDrawer } from './styles';

const BottomDrawer = ({ drawerComponent, ...rest }) => (
  <PadlessDrawer
    placement="bottom"
    mask={false}
    destroyOnClose
    {...rest}
  >
    {drawerComponent}
  </PadlessDrawer>
);

export default BottomDrawer;
